<template>
  <div class="index">
    <!-- 选择查询条件 -->
    <div class="index-header">
      <el-form :model="filterForm" :inline="true" label-width="100px">
        <div class="input-box">
          <div>
            <!-- <el-form-item label="申请账号：">
              <el-input v-model="filterForm.name" placeholder="请输入名称"></el-input>
            </el-form-item> -->
            <el-form-item label="申请状态：">
              <el-select v-model="filterForm.status" clearable placeholder="请选择申请状态">
                <el-option v-for="(x,i) in $fuwuData.layerApplyStatus" :key="i" :label="x.label" :value="x.val">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button type="primary" @click="filterClick()" icon="el-icon-search">查询</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <!-- 数据表格 -->
    <div class="table">
      <el-table :data="tableData" border>
        <el-table-column show-overflow-tooltip v-for="(x,i) in tableInfo" :key="i" :prop="x.key" :label="x.value" align="center"></el-table-column>
        <el-table-column label="审核状态" prop="status" align="center">
          <template slot-scope="scope">
            <el-select v-model="scope.row.status" placeholder="请选择状态">
              <el-option v-for="(x,i) in $fuwuData.layerApplyStatus" :key="i" :label="x.label" :value="x.val"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="150px">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="modifyHandler(scope.row)">确认</el-button>
          </template>
        </el-table-column>
        <el-table-column label="查看信息" type="expand">
          <template slot-scope="scope">
            <div class="detailbox">
              <li class="li">
                <span>上传审核图片：</span> 
                <template v-if="scope.row.imgId">
                  <span class="imgspan" v-for="(x,i) in scope.row.imgId" :key="i">
                    <el-image
                      style="width: 100px; height: 100px" :src="puUrl_x+'/'+x"
                      :preview-src-list="previewImgList" @click="previewImg(scope.row.imgId,i)"></el-image>
                  </span>
                </template>
                <template v-else>
                  <span class="imgspan">未上传营业执照</span>
                </template>
              </li>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <paging :pagesData="pageData" @set_page_number="pageChange"></paging>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sign: 'lvshisq',
      tableData: [],//请求到的 ‘律师请求’ 数据，渲染到表格中
      filterForm: {},//查询数据表单
      tableInfo:[
        // { value: '申请账号', key: 'user' },
        { value: '申请人', key: 'user.u_nickName' },
        { value: '申请账号', key: 'user.name' },
        { value: '申请时间', key: 'showDate' },
      ],
      previewImgList:[],//预览模式下的图片数组
      
      //分页数据
      pageData: {
        currentPage: 1,
        pageSize: 40,
        total: 0,
      },
    }
  },
  methods:{
    // 后台 服务方面的 分页
    pageChange(pageNumer) {
      this.pageData.currentPage = pageNumer
      this.filterHandler()
    },
    // 点击图片，进行预览
    previewImg(arr, index) {
      this.previewImgList = new Array(arr.length)
      arr.forEach((x, i) => {
        // 当遍历索引大于点击对应的索引时，将这个值赋给 索引为i-index的元素
        // 当遍历索引小于点击对应的索引时，将这个值赋给 索引为i+length-index的元素
        let imgUrl = this.puUrl_x + '/' + x
        if (i >= index) {
          this.previewImgList[i - index] = imgUrl
        } else {
          this.previewImgList[i + arr.length - index] = imgUrl
        }
      })
    },
    filterClick() {
      this.pageData.currentPage = 1
      this.filterHandler()
    },
    filterHandler(rD = {}) {
      rD = JSON.parse(JSON.stringify(this.filterForm))
      rD.status === '' ? delete rD.title : ''
      this.getData(rD)
    },
    modifyHandler(row) {//更改审核状态
      let { id, status } = row
      let rD = { id, status }
      this.$api.util_modify(this.sign, rD).then(res => {
        if (res.data.status == 0) {
          this.$message.success('审核状态已更新！')
          this.filterHandler()
        } else { this._status(res.data) }
      })
    },
    getData(rD = {}) {
      rD.pageNumber = this.pageData.currentPage
      this.$api.util_search(this.sign, rD).then(res => {
        if (res.data.status == 0) {
          this.tableData = JSON.parse(res.data.data)
          this.pageData.total = res.data.size
          console.log(this.tableData)
        } else { this._status(res.data) }
      })
    },
  },
  created() {
    this.filterHandler()
  },
}
</script>

<style lang='scss' scoped>
/* @import url(); 引入css类 */
.input-box>div{display: flex;flex-direction: column;flex-shrink: 0;}
.detailbox .li{display: flex;}
.detailbox .li span{margin: 0px 10px;}
</style>